module.exports = __webpack_public_path__ + "static/img/AD.e0c6a498.svg";